import { Injectable } from '@angular/core'
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from './auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    console.log('auth guard activated')
    if (!this.auth.isLoggedIn) {
      console.log('redirecting to', state.url)
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
      })
      return false
    }
    console.log(this.auth.user)
    // fire-and-forget: ejects soft-deleted users once the throttled
    // status check responds; navigation itself is not blocked
    this.auth.checkAccountActive()
    return true
  }
}
